'use strict';

var SummaryDashboardLegendFilterService = function SummaryDashboardLegendFilterService() {
  var DEFAULT_DIRECTION = 'OUTBOUND';
  var selectedMarkets, selectedCabins, selectedPoses;
  var selectedDirection = DEFAULT_DIRECTION;
  function setSelectedMarkets(markets) {
    selectedMarkets = markets || [];
  }
  function setSelectedCabins(cabins) {
    selectedCabins = cabins || [];
  }
  function setSelectedPoses(poses) {
    selectedPoses = poses || [];
  }
  function setSelectedDirection(direction) {
    selectedDirection = direction;
  }
  function getSelectedMarkets() {
    return selectedMarkets;
  }
  function getSelectedCabins() {
    return selectedCabins;
  }
  function getSelectedPoses() {
    return selectedPoses;
  }
  function getSelectedDirection() {
    return selectedDirection;
  }
  function isFilterEmpty() {
    return selectedMarkets === null && selectedCabins === null && selectedPoses === null;
  }
  function resetFilters() {
    selectedMarkets = null;
    selectedCabins = null;
    selectedPoses = null;
    selectedDirection = DEFAULT_DIRECTION;
  }
  return {
    setSelectedMarkets: setSelectedMarkets,
    setSelectedCabins: setSelectedCabins,
    setSelectedPoses: setSelectedPoses,
    setSelectedDirection: setSelectedDirection,
    getSelectedMarkets: getSelectedMarkets,
    getSelectedCabins: getSelectedCabins,
    getSelectedPoses: getSelectedPoses,
    getSelectedDirection: getSelectedDirection,
    isFilterEmpty: isFilterEmpty,
    resetFilters: resetFilters
  };
};
SummaryDashboardLegendFilterService.$inject = [];
module.exports = SummaryDashboardLegendFilterService;